import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs';

import { KillswitchFeatureFlagToggles } from '../interface/feature-flags.interfaces';
import { DataAccessTogglesFacade } from '../states/toggles/data-access-toggles.facade';

@Injectable()
export class KillSwitchActiveGuard {
  constructor(private togglesFacade: DataAccessTogglesFacade, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, __: RouterStateSnapshot) {
    const featureFlag = route.data['killSwitch'] as KillswitchFeatureFlagToggles;
    const redirectUrl = route.data['redirectUrl'] as string;

    return this.togglesFacade.flag(featureFlag).pipe(
      take(1),
      map((status: boolean | undefined) => {
        if (status) {
          return this.router.navigate([redirectUrl ?? '/']);
        }

        return true;
      })
    );
  }
}

export function killSwitchActive(featureFlag: KillswitchFeatureFlagToggles, redirectUrl?: string) {
  return () => {
    const router = inject(Router);
    const facade = inject(DataAccessTogglesFacade);

    return facade.flag(featureFlag).pipe(
      take(1),
      map((status: boolean | undefined) => {
        if (status) {
          return router.navigate([redirectUrl ?? '/']);
        }

        return true;
      })
    );
  };
}
